import React from 'react';
import { render } from 'react-dom';
import { Router, browserHistory } from 'react-router';

// Import your routes so that you can pass them to the <Router /> component
import routes from './routes.js';

const setVh = () => {
  let vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}

setVh()

if (window.location.pathname.indexOf('/video') == 0) {
  window.addEventListener('resize', setVh)
  window.addEventListener('DOMContentLoaded', setVh)
}

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag('js', new Date());

gtag('config', 'G-MZZYTL11ET');

render((
  <Router routes={routes} history={browserHistory} />
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./client/index.js